module.exports = __webpack_public_path__ + "img/morozov-small.cacf8845.webp";